import styles from "./HowItWorksSection.module.css";

interface Step {
  readonly number: string;
  readonly text: string;
  readonly colorClass: string;
}

const STEPS: Step[] = [
  { number: "01", text: "Начинаете наш марафон", colorClass: "step1" },
  { number: "02", text: "Получаете задания на каждый день", colorClass: "step2" },
  { number: "03", text: "Выполняете вместе с ребёнком", colorClass: "step3" },
  { number: "04", text: "Отмечаете прогресс ребенка", colorClass: "step4" },
  { number: "05", text: "Получаете обратную связь от логопеда", colorClass: "step5" },
];

export const HowItWorksSection = () => {
  return (
    <section className={styles.section} aria-label="Как проходит марафон">
      <div className={styles.container}>
        <h2 className={styles.title}>
          Как проходит марафон{" "}
          <span className={styles.emoji} aria-hidden="true">🧩</span>
        </h2>

        <div className={styles.stepsGrid}>
          {STEPS.map((step) => (
            <div key={step.number} className={styles.stepItem}>
              <div className={`${styles.circle} ${styles[step.colorClass]}`}>
                {step.number}
              </div>
              <p className={styles.stepText}>{step.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};